import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SplashscreenService } from 'src/app/shared/services/splashscreen.service';

@Injectable()
export class ProjectStatsDataService {
  constructor(
    private readonly http: HttpClient,
    private readonly splashscreenService: SplashscreenService
  ) { }

  getCounts(): Observable<any> {
    return this.http.get('/api/ProjectCountPerRegionAndSector').pipe(
      tap({
        next: () => this.splashscreenService.notifyFirstWidgetDataLoaded(),
        error: () => this.splashscreenService.notifyFirstWidgetDataLoaded()
      })
    );
  }

  getCapex(): Observable<any> {
    return this.http.get('/api/ProjectCAPEXPerRegionAndSector').pipe(
      tap({
        next: () => this.splashscreenService.notifyFirstWidgetDataLoaded(),
        error: () => this.splashscreenService.notifyFirstWidgetDataLoaded()
      })
    );
  }
}
